'use strict';

var BROWSER_TYPE = require('./constant/browser_type');
var callApp = require('./call_app');

module.exports = {
  BROWSER_TYPE: BROWSER_TYPE,
  callApp: callApp
};